import { Quotes, Star } from "@phosphor-icons/react";
import { TESTIMONIALS } from "@/data/content";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

export const Testimonials = () => (
  <section data-testid="testimonials" className="relative border-t border-white/10 bg-panel/40 py-24 md:py-32">
    <div className="mx-auto max-w-[1440px] px-6 md:px-12">
      <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <div className="mb-4 flex items-center gap-3">
            <span className="h-px w-10 bg-brand-cyan" />
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cyan">Trust</span>
          </div>
          <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-[0.98] tracking-tight md:text-5xl">
            What clients and partners say.
          </h2>
        </div>
        <div className="flex items-center gap-2">
          {[...Array(5)].map((_, i) => <Star key={i} size={18} weight="fill" className="text-brand-cyan" />)}
          <span className="ml-2 font-mono text-xs uppercase tracking-widest text-slatex-300">Google Reviews</span>
        </div>
      </Reveal>

      <Stagger className="grid gap-4 md:grid-cols-2">
        {TESTIMONIALS.map((t) => (
          <StaggerItem key={t.name} className="group flex flex-col justify-between border border-white/10 bg-ink p-8 transition-colors hover:border-white/25 md:p-10">
            <div>
              <Quotes size={28} weight="fill" className="text-brand-cyan/50" />
              <p className="mt-5 font-body text-lg leading-relaxed text-white">"{t.quote}"</p>
            </div>
            <div className="mt-8 flex items-center justify-between border-t border-white/10 pt-5">
              <div>
                <div className="font-display font-semibold text-white">{t.name}</div>
                <div className="font-mono text-[11px] uppercase tracking-wide text-slatex-500">{t.role}</div>
              </div>
              <span className="border border-white/12 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-brand-cyan">{t.tag}</span>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);

export default Testimonials;
